export const stableQueryKeys = {
    BOOTSTRAP_QUERY_KEY: ['bootstrap'],
    ENABLED_FEATURES_QUERY_KEY: ['enabled-features'],
} as const;
